"use client";

import Link from "next/link";

const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-primary">ApniList</h3>
            <p className="text-sm text-muted-foreground">
              Buying guides, practical comparisons and recorded prices for Indian shoppers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/articles" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Articles
                </Link>
              </li>
              <li>
                <Link href="/price-tracker" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Price Tracker
                </Link>
              </li>
              <li>
                <Link href="/deals" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Daily Deals
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">About & policies</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link href="/editorial-policy" className="text-sm text-muted-foreground hover:text-primary">How we research</Link>
              </li><li>
                <Link href="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <p className="text-sm text-muted-foreground">
              Sector 14, Gurugram<br />
              Haryana, India
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border text-center text-sm text-muted-foreground space-y-2">
          <p>
            <strong>Affiliate disclosure:</strong> ApniList participates in the Amazon Associates
            Programme and the Flipkart Affiliate Programme. We may earn a commission from
            qualifying purchases — at no extra cost to you.
          </p>
          <p>© {new Date().getFullYear()} ApniList. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;